import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  Bar, BarChart, ResponsiveContainer, XAxis, YAxis,
} from 'recharts';
import Typography from 'Components/UI/Typography';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';
import classNames from 'classnames';

const useStyles = buildUseStyles('ManagedAccountPortfolioBarChart', (theme) => ({
  root: {
    width: '100%',
  },
  ratio: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    gap: theme.spacing(0.5),
  },
  ratioText: {
    color: theme.palette.facet.primaryText,
    fontWeight: theme.typography.fontWeightBold,
    whiteSpace: 'nowrap',
    '&:last-child': {
      textAlign: 'right',
    },
    '&:first-child': {
      textAlign: 'left',
    },
  },
  chartContainer: {
    display: 'flex',
    gap: theme.spacing(0.5),
    width: '100%',
    borderRadius: theme.radius.sm,
    overflow: 'hidden',
    minHeight: 36,
  },
  skinny: {
    minHeight: 24,
  },
}));

export default function ManagedAccountPortfolioBarChart({ allocationModelClassifications, simple, skinny = false }) {
  const { logPortfolioHorizontalBarChart } = useManagedAccountPageEventLogger();

  const classes = useStyles();

  return <>
    <Box className={classes.root}>
      <Box className={classes.ratio}>
        {allocationModelClassifications.map(classification => <Typography key={classification.name} style={{ flex: classification.value }} className={classes.ratioText}>{allocationModelClassifications.length <= 3 ? classification.name : classification.type}</Typography>)}
      </Box>
      <Box className={classNames(classes.chartContainer, { [classes.skinny]: skinny })}>
        {allocationModelClassifications.map(classification => {
          const data = simple ? [classification] : classification.tickerClassifications;
          const chartData = [data.reduce((acc, curr) => ({ ...acc, [curr.name]: curr.value }), { name: classification.type })];

          function handlePortfolioChartClick(_, index) {
            logPortfolioHorizontalBarChart('Sector', {
              name: chartData[index].name,
            });
          }

          return (<>
            <Box key={classification.name} flex={classification.value}>
              <ResponsiveContainer>
                <BarChart
                  layout="vertical"
                  data={chartData}
                  barCategoryGap={0}
                  barGap={0}
                  margin={{
                    top: 0, right: 0, bottom: 0, left: 0,
                  }}
                >
                  <XAxis type="number" domain={['dataMin', 'dataMax']} hide />
                  <YAxis type="category" dataKey="name" hide />
                  {data.map(d => (<Bar
                    key={d.name}
                    dataKey={d.name}
                    stackId="a"
                    fill={d.color}
                    onClick={handlePortfolioChartClick}
                  />))}
                </BarChart>
              </ResponsiveContainer>
            </Box>
          </>);
        })}
      </Box>
    </Box>
  </>;
}
